import { render, staticRenderFns } from "./CompositeProductComposition.vue?vue&type=template&id=31f61e96&scoped=true&"
import script from "./CompositeProductComposition.vue?vue&type=script&lang=js&"
export * from "./CompositeProductComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f61e96",
  null
  
)

export default component.exports